<div class="relative">
  <!-- FLOATING HAMBURGER BUTTON -->
  <button
    class="sidebar-toggle absolute top-0.5 -right-9 z-50 w-9 h-9 rounded-full bg-white shadow-lg flex items-center justify-center border border-gray-300 hover:shadow-xl transition-all duration-300 lg:hidden"
    (click)="hidehamburger = !hidehamburger" matTooltip="Toggle Menu">
    <mat-icon class="transition-transform duration-700" [ngClass]="hidehamburger ? 'rotate-360' : 'rotate-0'">
      {{ hidehamburger ? 'menu' : 'menu_open' }}
    </mat-icon>
  </button>
</div>
<div class="flex flex-col h-full bg-white relative transition-all duration-300"
  [ngClass]="hidehamburger ? 'hidden lg:w-[300px] lg:flex' : 'w-[190px] lg:w-[300px] flex'">
  <!-- Scrollable menu -->
  <div class="flex-1 overflow-y-auto py-4">
    <ul class="flex flex-col gap-2 text-base">
      <li class="space-y-5">
        <a routerLinkActive="bg-[#05143F] active" [routerLinkActiveOptions]="{exact:false}"
          [routerLink]="[routePrefix + '/dashboard']"
          class="flex flex-col lg:flex-row items-center gap-3 px-5 py-3 text-sm">
          <img src="./images/sidebar-icons/dashboard-logo.svg" class="icon-default w-5 h-5" alt="" />
          <img src="./images/sidebar-icons/dashboard-active-icon.svg" class="icon-active w-5 h-5" alt="" />
          <p class="font-bold text-[13px]">Dashboard</p>
        </a>
      </li>
      <li class="space-y-5" *ngIf="roleId != 1 && roleId != 18">
        <a routerLinkActive="bg-[#05143F] active" [routerLinkActiveOptions]="{exact:false}"
          routerLink="/task-management" class="flex flex-col lg:flex-row items-center gap-3 px-5 py-3 text-sm">
          <img src="./images/sidebar-icons/task-square.svg" class="icon-default w-5 h-5" alt="" />
          <img src="./images/sidebar-icons/task-square-active.svg" class="icon-active w-5 h-5" alt="" />
          <p class="font-bold text-[13px]">Task Management</p>
        </a>
      </li>
      <li class="space-y-5" *ngIf="roleId == 1 || roleId == 11 || roleId == 18">
        <a routerLinkActive="bg-[#05143F] active" [routerLinkActiveOptions]="{exact:false}"
          [routerLink]="[routePrefix + '/user-management']"
          class="flex flex-col lg:flex-row items-center gap-3 px-4 py-3 text-sm">
          <img src="./images/sidebar-icons/user-mgnt-logo.svg" class="icon-default w-5 h-5" alt="" />
          <img src="./images/sidebar-icons/user-mgnt-active-logo.svg" class="icon-active w-5 h-5" alt="" />
          <p class="font-bold text-[13px]">Staff Management</p>
        </a>
      </li>
      <li class="space-y-5" *ngIf="roleId == 11">
        <a routerLinkActive="bg-[#05143F] active" [routerLinkActiveOptions]="{exact:false}"
          routerLink="hr-manager/recruitment-management"
          class="flex flex-col lg:flex-row items-center gap-3 px-4 py-3 text-sm">
          <img src="./images/sidebar-icons/project-mgnt-logo.svg" class="icon-default w-5 h-5" alt="" />
          <img src="./images/sidebar-icons/recruitment-mgnt-active.svg" class="icon-active w-5 h-5" alt="" />
          <p class="font-bold text-[13px] text-center">Recruitment Management</p>
        </a>
      </li>
      <li class="space-y-5"
        *ngIf="roleId == 1 || roleId == 2 || roleId == 18 || roleId == 16 || roleId == 17 || roleId == 20 || roleId == 19 || roleId == 9 || roleId == 4  || roleId == 8">
        <a routerLinkActive="bg-[#05143F] active" [routerLinkActiveOptions]="{exact:false}"
          [routerLink]="[routePrefix + '/project-management']"
          class="flex flex-col lg:flex-row items-center gap-3 px-5 py-3 text-sm">
          <img src="./images/sidebar-icons/project-mgnt-logo.svg" class="icon-default w-5 h-5" alt="" />
          <img src="./images/sidebar-icons/project-mgnt-active-logo.svg" class="icon-active w-5 h-5" alt="" />
          <p class="font-bold text-[13px] text-center">Project Management</p>
        </a>
      </li>
      <li class="space-y-5" *ngIf="roleId == 3 || roleId == 9 || roleId == 19">
        <a routerLinkActive="bg-[#05143F] active" [routerLinkActiveOptions]="{exact:false}"
          [routerLink]="[routePrefix + '/data-sync']"
          class="flex flex-col lg:flex-row items-center gap-3 px-5 py-3 text-sm">
          <img src="./images/sidebar-icons/project-mgnt-logo.svg" class="icon-default w-5 h-5" alt="" />
          <img src="./images/sidebar-icons/project-mgnt-active-logo.svg" class="icon-active w-5 h-5" alt="" />
          <p class="font-bold text-[13px] text-center">Data Sync</p>
        </a>
      </li>
      <li class="space-y-5" *ngIf="roleId == 3">
        <a routerLinkActive="bg-[#05143F] active" [routerLinkActiveOptions]="{exact:false}"
          [routerLink]="[routePrefix + '/task-monitoring']"
          class="flex flex-col lg:flex-row items-center gap-3 px-5 py-3 text-sm">
          <img src="./images/sidebar-icons/task-square.svg" class="icon-default w-5 h-5" alt="" />
          <img src="./images/sidebar-icons/task-square-active.svg" class="icon-active w-5 h-5" alt="" />
          <p class="font-bold text-[13px] text-center">Task Monitoring</p>
        </a>
      </li>
      <li class="space-y-5" *ngIf="roleId == 1 || roleId == 2 || roleId == 9  || roleId == 18">
        <a routerLinkActive="bg-[#05143F] active" [routerLinkActiveOptions]="{exact:false}"
          routerLink="/performance-management" class="flex flex-col lg:flex-row items-center gap-3 px-5 py-3 text-sm">
          <img src="./images/sidebar-icons/performance-mgnt-logo.svg" class="icon-default w-5 h-5" />
          <img src="./images/sidebar-icons/performance-mgnt-active-logo.svg" class="icon-active w-5 h-5" />
          <p class="font-bold text-[13px] text-center">Performance Management</p>
        </a>
      </li>
      <!-- resource management icon change -->
      <li class="space-y-5" *ngIf="roleId == 1 || roleId == 10 || roleId == 18 || roleId == 9">
        <a routerLinkActive="bg-[#05143F] active" [routerLinkActiveOptions]="{exact:false}"
          [routerLink]="[routePrefix + '/resource-management']"
          class="flex flex-col lg:flex-row items-center gap-3 px-5 py-3 text-sm">
          <img src="./images/sidebar-icons/device-mgnt-active-logo.svg" class="icon-default w-5 h-5" alt="" />
          <img src="./images/sidebar-icons/device-mgnt-logo.svg" class="icon-active w-5 h-5" alt="" />
          <p class="font-bold text-[13px]">Device Management</p>
        </a>
      </li>
      <li class="space-y-5" *ngIf="roleId==10 || roleId==9">
        <a routerLinkActive="bg-[#05143F] active" [routerLinkActiveOptions]="{exact:false}"
          [routerLink]="[routePrefix + '/request-management']"
          class="flex flex-col lg:flex-row items-center gap-3 px-5 py-3 text-sm">
          <img src="./images/sidebar-icons/training-center-logo.svg" class="icon-default w-5 h-5" alt="" />
          <img src="./images/sidebar-icons/training-center-logo-active.svg" class="icon-active w-5 h-5" alt="" />
          <p class="font-bold text-[13px]">Requests</p>
        </a>
      </li>
      <li class="space-y-5"
        *ngIf="roleId == 1 || roleId == 2  || roleId == 18 || roleId == 11 || roleId == 4 || roleId == 6 || roleId == 8 || roleId == 9">
        <a routerLinkActive="bg-[#05143F] active" [routerLinkActiveOptions]="{exact:false}"
          routerLink="/training/training-center" class="flex flex-col lg:flex-row items-center gap-3 px-5 py-3 text-sm">
          <img src="./images/sidebar-icons/training-center-logo.svg" class="icon-default w-5 h-5" alt="" />
          <img src="./images/sidebar-icons/training-center-logo-active.svg" class="icon-active w-5 h-5" alt="" />
          <p class="font-bold text-[13px]">Training Center</p>
        </a>
      </li>
      <li class="space-y-5" *ngIf="roleId == 1 || roleId == 2  || roleId == 9  || roleId == 4 || roleId == 14">
        <a routerLinkActive="bg-[#05143F] active" [routerLinkActiveOptions]="{exact:true}" routerLink="payment/payment"
          class="flex flex-col lg:flex-row items-center gap-3 px-5 py-3 text-sm">
          <img src="./images/sidebar-icons/payment-mgnt-logo.svg" class="icon-default w-5 h-5" alt="" />
          <img src="./images/active-wallet-icon.svg" class="icon-active w-5 h-5" alt="" />
          <p class="font-bold text-[13px] text-center">Payment Management</p>
        </a>
      </li>
      <li class="space-y-5">
        <a routerLinkActive="bg-[#05143F] active" [routerLinkActiveOptions]="{exact:false}" routerLink="/communication"
          class="flex flex-col lg:flex-row items-center gap-3 px-5 py-3 text-sm">
          <img src="./images/sidebar-icons/communication-logo.svg" class="icon-default w-5 h-5" alt="" />
          <img src="./images/sidebar-icons/communication-active-logo.svg" class="icon-active w-5 h-5" alt="" />
          <p class="font-bold text-[13px]">Communication</p>
        </a>
      </li>
      <!-- <li class="space-y-5" *ngIf="roleId==10">
        <a routerLinkActive="bg-[#05143F] active" [routerLinkActiveOptions]="{exact:false}"
          class="flex flex-col lg:flex-row items-center gap-3 px-5 py-3 text-sm">
          <img src="./images/sidebar-icons/training-center-logo.svg" class="icon-default w-5 h-5" alt="" />
          <img src="./images/sidebar-icons/training-center-logo-active.svg" class="icon-active w-5 h-5" alt="" />
          <p class="font-bold text-[13px]">Payment</p>
        </a>
      </li> -->
      <li class="space-y-5">
        <a routerLinkActive="bg-[#05143F] active" [routerLinkActiveOptions]="{exact:false}" routerLink="user/profile"
          class="flex flex-col lg:flex-row items-center gap-3 px-5 py-3 text-sm">
          <img src="./images/sidebar-icons/profile-logo.svg" class="icon-default w-5 h-5" alt="" />
          <img src="./images/sidebar-icons/profile-active-logo.svg" class="icon-active w-5 h-5" alt="" />
          <p class="font-bold text-[13px]">Profile</p>
        </a>
      </li>
    </ul>
  </div>
  <!-- Network Section -->
  <div class="px-2 py-1 bg-[#05143F] mt-auto">
    <div class="flex items-center gap-2">
      <mat-icon [color]="network.color" class="border border-solid rounded-md underline" matTooltip="{{network.label}}">
        {{ network.icon }}
      </mat-icon>
      <span class="text-xs text-white opacity-70">{{ network.label }}</span>
    </div>
  </div>
</div>